import { create } from "zustand";

type TGenerationStatus =
  | "pending"
  | "processing"
  | "streaming"
  | "ready"
  | "processed"
  | "error"
  | "errorSeen"
  | "cancelled";

interface ProjectSetupStore {
  activeSetupTasks: Record<string, number>;
  taskStatuses: Record<string, TGenerationStatus>;
  setSetupTask: (projectId: string, taskId: number) => void;
  updateTaskStatus: (projectId: string, status: TGenerationStatus) => void;
  clearSetupTask: (projectId: string) => void;
  getSetupTask: (projectId: string) => number | null;
}

export const useProjectSetupStore = create<ProjectSetupStore>()((set, get) => ({
  activeSetupTasks: {},
  taskStatuses: {},

  setSetupTask: (projectId, taskId) =>
    set((state) => ({
      activeSetupTasks: { ...state.activeSetupTasks, [projectId]: taskId }
    })),

  updateTaskStatus: (projectId, status) =>
    set((state) => ({
      taskStatuses: { ...state.taskStatuses, [projectId]: status }
    })),

  clearSetupTask: (projectId) =>
    set((state) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [projectId]: _task, ...restTasks } = state.activeSetupTasks;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [projectId]: _status, ...restStatuses } = state.taskStatuses;
      return { activeSetupTasks: restTasks, taskStatuses: restStatuses };
    }),

  getSetupTask: (projectId) => get().activeSetupTasks[projectId] || null
}));
